import { render, staticRenderFns } from "./headimg.vue?vue&type=template&id=022bf768&"
import script from "./headimg.vue?vue&type=script&lang=js&"
export * from "./headimg.vue?vue&type=script&lang=js&"
import style0 from "./headimg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports